import React, { useState, useEffect, Fragment, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
import Modal from "react-modal";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";

import logoHead from "./logo/cder_logo.png";

import { Request_submit } from "./request_submit";
import { PassModal2 } from "./passwordChangeModal2";
import { MenuCollaps } from "./menu-collaps";
import { ResponsivePie } from "@nivo/pie";
import { set } from "date-fns";

export const Dashboard = ({ setAuth, setPage }) => {
  const [name, setName] = useState("");
  const [priv, setPriv] = useState("");
  const [reqManagePriv, setReqManagePriv] = useState(false);

  const [empSelected, setEmpSelected] = useState(false);
  const [currentEmp, setCurrentEmp] = useState(null);
  const [passChangeConfirmed, setPassChangeConfirmed] = useState(false);
  const [modalDisconnectIsOpen, setModalDisconnectIsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMentor, setIsMentor] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(null);
  const openModal = () => {
    setModalDisconnectIsOpen(true);
  };

  const closeModal = () => {
    setModalDisconnectIsOpen(false);
    logout();
  };

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setPriv(parsRes.emp_level);
      setReqManagePriv(parsRes.emp_trainees_manager);
      setCurrentEmp(parsRes.emp_id);
      if (parseInt(parsRes.emp_level) === 1) {
        setIsAdmin(true);
      }

    } catch (err) {
      console.error(err.message);
    }
  }

  const [requests, setRequests] = useState([]);


  const getRequests = async () => {
    // Get all current requests by the user
    const allRequests = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/requests`
    );
    const parseRes = await allRequests.json();

    const sortedRequests = parseRes.sort((a, b) =>
      a.req_date > b.req_date ? 1 : -1
    );
    setRequests(sortedRequests);
    // setRequests(parseRes);
    // sort requests by the req_date column

    // console.log(sortedRequests);

    // console.log(parseRes);
  };

  const [usersList, setUsersList] = useState([]);

  async function getUsersList() {
    try {
      const resp = await fetch(`/api/employees`, {
        method: "GET",
        headers: { token: localStorage.token },
      })
      const parsRes = await resp.json();
      setUsersList(parsRes.sort((a, b) => a.emp_name.localeCompare(b.emp_name)));

    } catch (err) {
      console.error(err.message);
    }
  }

  console.log(usersList);

  async function checkIfMentor(currentEmp) {
    try {
      const resp = await fetch(
        `/api/checkIsMentor/${currentEmp}`, {
        method: "GET",
        headers: { token: localStorage.token },
      }
      );
      const parsRes = await resp.json();
      setIsMentor(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }
  const toasty = useRef(null);
  console.log(isMentor);
  const accept2 = () => {
    toasty.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "Mot de passe Modifié",
      life: 5000,
    });
  };

  useEffect(() => {
    if (name != undefined || name != null) {
      if (name.length > 0) {
        setEmpSelected(true);
      }
    }
  }, [name]);

  const logout = () => {
    localStorage.removeItem("token");
    setAuth(false);
    toast("Déconnecté");
  };

  useEffect(() => {
    getName();
  });

  useEffect(() => {
    if (currentEmp !== undefined || currentEmp !== null || currentEmp !== "") {
      checkIfMentor(currentEmp);
    }
  }, [currentEmp]);

  function toggleDropdown() {
    const dropdown = document.getElementById("dropdown");
    dropdown.classList.toggle("hidden");
  }

  function toggleDropdown2() {
    const dropdown2 = document.getElementById("dropdown2");
    dropdown2.classList.toggle("hidden");
  }

  function handleClickOutside(event) {
    const dropdown = document.getElementById("dropdown");
    const button = document.getElementById("dropdownButton");

    if (dropdown !== null && button !== null) {
      if (!dropdown.contains(event.target) && !button.contains(event.target)) {
        dropdown.classList.add("hidden");
      }
    }
  }

  function handleClickOutside2(event) {
    const dropdown2 = document.getElementById("dropdown2");
    const button2 = document.getElementById("dropdownButton2");

    if (dropdown2 !== null && button2 !== null) {
      if (
        !dropdown2.contains(event.target) &&
        !button2.contains(event.target)
      ) {
        dropdown2.classList.add("hidden");
      }
    }
  }

  // When the dropdown is shown, add the listener
  document.addEventListener("click", handleClickOutside);
  document.addEventListener("click", handleClickOutside2);

  const handlePassChangeConfirmation = (newValue) => {
    setPassChangeConfirmed(newValue);
  };

  useEffect(() => {
    if (passChangeConfirmed === true) {
      accept2();
      openModal();
    }
  }, [passChangeConfirmed]);

  const showSideBar = () => {
    const sideBar = document.querySelector(".side-nav");
    sideBar.style.display = "flex";
  };

  const hideSideBar = () => {
    const sideBar = document.querySelector(".side-nav");
    sideBar.style.display = "none";
  };

  const [structures, setStructures] = useState([]);

  const getStructures = async () => {
    const resp = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/structures`,
      {
        method: "GET",
        headers: { token: localStorage.token },
      }
    );
    const parsRes = await resp.json();
    // console.log(parsRes);
    setStructures(parsRes);
  };

  const [internshipRequestStats, setInternshipRequestStats] = useState([]);

  const getInternshipRequestsStats = async () => {
    const resp = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/apprenticeshipRequestsStats`,
      {
        method: "GET",
        headers: { token: localStorage.token },
      }
    );
    const parsRes = await resp.json();
    // console.log(parsRes);
    setInternshipRequestStats(parsRes);
  };

  useEffect(() => {
    getInternshipRequestsStats();
    getStructures();

  }, []);

  useEffect(() => {
    if (isAdmin) {
      getUsersList();
    }
  }, [isAdmin])


  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  useEffect(() => {
    if (internshipRequestStats.length !== 0) {
      const newData = [
        {
          id: "Université",
          label: "Université",
          value: parseInt(internshipRequestStats.requestData.UNI),
          color: "hsl(14, 70%, 50%)",
        },
        {
          id: "Centre Universitaire",
          label: "Centre Universitaire",
          value: parseInt(internshipRequestStats.requestData.UNI_CENTER),
          color: "hsl(249, 70%, 50%)",
        },
        {
          id: "CFPA",
          label: "CFPA",
          value: parseInt(internshipRequestStats.requestData.CFPA),
          color: "hsl(84, 70%, 50%)",
        },
      ];
      setData(newData);
    }

    let newData2 = [];
    for (let i = 0; i < structures.length; i++) {
      for (
        let j = 0;
        j < internshipRequestStats.requestData.Asigned_STR.length;
        j++
      ) {
        if (
          internshipRequestStats.requestData.Asigned_STR[j]
            .intern_req_asigned_str === structures[i].str_id
        ) {
          newData2.push({
            id: structures[i].str_name,
            label: structures[i].str_name,
            value: parseInt(
              internshipRequestStats.requestData.Asigned_STR[j].count
            ),
          });
        }
      }
    }
    setData2(newData2);
  }, [internshipRequestStats]);

  const totalAppReqCount = data.reduce(
    (acc, current) => acc + current.value,
    0
  );

  const totalAppReqAsignedCount = data2.reduce(
    (acc, current) => acc + current.value,
    0
  );

  const MyResponsivePie = ({ data, total }) => {
    return (
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
        colors={{
          type: "spectral",
          scheme: "category10",
          colors: "spe",
        }}
        // layers={["arcs", "arcLabels", "arcLinkLabels", "legends", totalAppReqCount]}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        fill={[
          {
            match: {
              id: "CFPA",
            },
            id: "dots",
          },

          {
            match: {
              id: "Université",
            },
            id: "lines",
          },

        ]}
        legends={[
          {
            anchor: "bottom",
            direction: "column",
            justify: false,
            translateX: -100,
            translateY: 80,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 10,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#000",
                },
              },
            ],
          },
        ]}
        layers={[
          ({ centerX, centerY, radius }) => (
            <text
              x={centerX}
              y={centerY}
              textAnchor="middle"
              fontSize={14}
              fontWeight="bold"
              fill="#333"
            >
              Totale: {total}
            </text>
          ),
          "arcs",
          "arcLabels",
          "arcLinkLabels",
          // "legends",
        ]}
      />
    );
  };

  return (
    <Fragment>
      <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            République Algérienne Démocratique et Populaire Ministère de
            l'Enseignement Supérieur et de la Recherche Scientifique Direction
            Générale de la Recherche Scientifique et du Développement
            Technologique
          </p>
        </div>
        <div className="banner-text-2">
          <span>EPST/Centre de Développement des Energies Renouvelables</span>
        </div>
      </div>

      <div className="topnav  ">
        <div onClick={showSideBar} className="menu-icon-container ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
            className="my-svg"
          >
            <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
          </svg>
        </div>
        <div className="left-menu-3">
          <div class="menu-button">
            <button>Demandes internes</button>
            <ul class="menu">
              <li>
                <Link to="/request_submit">Faire une demande</Link>
              </li>
              <li>
                <Link to="/request_approve">Approuver des demandes</Link>
              </li>
              <li>
                <Link to="/MyRequests">Mes demandes</Link>
              </li>
            </ul>
          </div>

          <div class="menu-button">
            {(reqManagePriv || isMentor) && (
              <button>Demandes externes</button>
            )}
            <ul class="menu">
              {reqManagePriv && (
                <>
                  <li>
                    <Link to="/Apprenticeship_req_treatment">
                      Traitement des demandes de stage
                    </Link>
                  </li>
                  <li>
                    <Link to="/Visit_request_treatment">
                      Traitement des demandes de visite
                    </Link>
                  </li>
                </>
              )}
              {isMentor && (
                <li>
                  <Link to="/Apprenticeship_request_asigned">
                    Demandes de stage affectées
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="left-menu">
          {/* <MenuCollaps /> */}

          <Link to="/request_submit">Faire une demande</Link>
          <Link to="/request_approve">Approuver des demandes</Link>

          <Link to="/MyRequests">Mes demandes</Link>

          {/*
          <Link to="/ApprenticeshipReq">Demande de stage</Link>
          <Link to="/Visit_request">Demande de visite</Link>
          */}
          <div>
            {reqManagePriv === true ? (
              <Link to="/Apprenticeship_req_treatment">
                Traitement des demandes de stage
              </Link>
            ) : (
              <div></div>
            )}
          </div>

          <div>
            {reqManagePriv === true ? (
              <Link to="/Visit_request_treatment">
                Traitement des demandes de visite
              </Link>
            ) : (
              <div></div>
            )}
          </div>
          {isMentor && (
            <Link to="/Apprenticeship_request_asigned">
              Demandes de stage affectées
            </Link>
          )}
        </div>
        <div className="right-menu">
          <div className=" relative flex items-center justify-center float-left pr-3">
            <div>
              {" "}
              {priv == 1 ? <Link to="/admin">Admin</Link> : <div></div>}{" "}
            </div>
            <span className="p-3 text-white">{name}</span>

            <div className="relative">
              <button
                className="pi pi-cog hover:bg-custom_blue2 hover:text-custom_blue1 px-4 py-2 rounded-md"
                onClick={toggleDropdown}
                style={{ color: "white", fontSize: "1.5rem" }}
                id="dropdownButton"
              ></button>
              <div
                id="dropdown"
                className="absolute hidden top-12 right-0 w-52 bg-custom_blue1 shadow-md rounded-md p-4 z-50"
              >
                <div className="flex items-center gap-3 text-white">
                  <div className="pi pi-key"></div>
                  <PassModal2
                    empSelected={empSelected}
                    currentEmp={currentEmp}
                    onPassChange={handlePassChangeConfirmation}
                  />
                </div>

                {/* <a href="#" class="block py-1 ">
                <div className="flex items-center gap-3">
                  <div className="pi pi-key"></div>
                  <span>Changer mon Mot de passe</span>
                </div>
              </a> */}
                {/* ... your dropdown content */}
              </div>
            </div>
            <div className="flex hover:bg-custom_blue2 hover:text-custom_blue1 px-2 py-2 h-[40px] rounded-md">

              <div
                className="pi pi-bell "
                onClick={toggleDropdown}
                style={{ color: "white", fontSize: "1.5rem" }}
                id="dropdownButton"
              ></div>
              <p className="text-white text-sm" >{pendingRequests}</p>

            </div>
          </div>
          <button className="dash-logout" onClick={(e) => logout(e)}>
            Se déconnecter
          </button>
        </div>
      </div>

      <div className="side-nav">
        <div onClick={hideSideBar} className="menu-close-icon-container ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
            className="my-svg"
          >
            <path
              fill="#FFFFFF"
              d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
            />
          </svg>
        </div>
        <Link to="/request_submit">Faire une demande</Link>
        <Link to="/request_approve">Approuver des demandes</Link>
        <Link to="/MyRequests">Mes demandes</Link>

        <div> {priv == 1 ? <Link to="/admin">Admin</Link> : <div></div>} </div>

        {/*
        <Link to="/ApprenticeshipReq">Demande de stage</Link>
        <Link to="/Visit_request">Demande de visite</Link>
        */}
        <div>
          {reqManagePriv === true ? (
            <Link to="/Apprenticeship_req_treatment">
              Traitement des demandes de stage
            </Link>
          ) : (
            <div></div>
          )}
        </div>

        <div>
          {reqManagePriv === true ? (
            <Link to="/Visit_request_treatment">
              Traitement des demandes de visite
            </Link>
          ) : (
            <div></div>
          )}
        </div>

        {isMentor && (
          <Link to="/Apprenticeship_request_asigned">
            Demandes de stage affectées
          </Link>
        )}


        <div className=" relative flex items-center justify-center float-left pr-3">
          <span className="p-3 text-white">{name}</span>

          <div className="relative">
            <button
              className="pi pi-cog hover:bg-custom_blue2 hover:text-custom_blue1 px-4 py-2 rounded-md"
              onClick={toggleDropdown2}
              style={{ color: "white", fontSize: "1.5rem" }}
              id="dropdownButton2"
            ></button>
            <div
              id="dropdown2"
              className="absolute hidden top-10 right-0 w-52 bg-custom_blue2 shadow-md rounded-md p-4"
            >
              <div className="flex items-center gap-3 text-white">
                <div className="pi pi-key"></div>
                <PassModal2
                  empSelected={empSelected}
                  currentEmp={currentEmp}
                  onPassChange={handlePassChangeConfirmation}
                />
              </div>

              {/* <a href="#" class="block py-1 ">
                <div className="flex items-center gap-3">
                  <div className="pi pi-key"></div>
                  <span>Changer mon Mot de passe</span>
                </div>
              </a> */}
              {/* ... your dropdown content */}
            </div>
          </div>
        </div>
        <button className="dash-logout" onClick={(e) => logout(e)}>
          Se déconnecter
        </button>
      </div>

      {/* <div className="dashboard-container">
        <h1 className="text-3xl font-bold underline">Dashboard</h1>
      </div> */}

      <Modal
        isOpen={modalDisconnectIsOpen}
        onRequestClose={closeModal}
        contentLabel="Add Comment"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <h5>Session expirée</h5>
        <p>Reconnectez-vous à votre compte</p>

        <div className=" flex content-center justify-center space-x-2">
          <button
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            id="password-change-confirm-btn"
            onClick={closeModal}
          >
            Okay
          </button>
        </div>
      </Modal>
      <div>
        {isAdmin && (
          <div className="dashboard-body-content">
            <div className="flex items-center justify-center flex-wrap">
              <div className="flex flex-col items-center w-auto border-2 bg-white border-gray-300 rounded-md p-2 m-2">
                <div className="w-[400px] h-[400px]">
                  <MyResponsivePie data={data} total={totalAppReqCount} />
                </div>
                <h5>Demandes de stage (par institut)</h5>
              </div>

              <div className="flex flex-col items-center w-auto border-2 bg-white border-gray-300 rounded-md p-2 m-2">
                <div className="w-[400px] h-[400px]">
                  <MyResponsivePie data={data2} total={totalAppReqAsignedCount} />
                </div>
                <h5>Demandes de stage (par affectation) </h5>
              </div>

            </div>
            <div className="users-list">
              <div className="sticky top-0 bg-gray-200 ">
                <h6 className="text-center ">Liste des Utilisateurs</h6>
              </div>
              <ul>
                {usersList.map((user) => <li>{user.emp_name}</li>)}
              </ul>
            </div>
          </div>
        )}
      </div>
      <Toast ref={toasty} />
      <ToastContainer />
    </Fragment>
  );
};
